module.exports = __webpack_public_path__ + "img/vip_room_min_1.02d51c2a.png";